import React from "react"
import {BankLogoProps, defaultBankLogoSize} from "./bankLogoUtils"

export function GenericBankFallbackLogo({size = defaultBankLogoSize, fill, className}: BankLogoProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			fill="none"
			viewBox="0 0 24 24"
			className={className}
		>
			<mask
				id="a"
				width={24}
				height={24}
				x={0}
				y={0}
				maskUnits="userSpaceOnUse"
				style={{
					maskType: "alpha",
				}}
			>
				<circle cx={12} cy={12} r={12} fill="#FBFBFB" />
			</mask>
			<g mask="url(#a)">
				<circle cx={12} cy={12} r={12} fill={fill} />
			</g>
			<g clipPath="url(#b)">
				<path
					fill="#000"
					fillRule="evenodd"
					d="M11.732 6.078a.5.5 0 0 1 .537 0l5.5 3.5a.5.5 0 0 1-.269.922h-11a.5.5 0 0 1-.268-.922l5.5-3.5ZM8.217 9.5h7.566L12 7.093 8.217 9.5ZM7.5 16v-4.5h1V16h-1Zm2.666 0v-4.5h1V16h-1Zm2.668 0v-4.5h1V16h-1Zm2.666 0v-4.5h1V16h-1Zm2.5 1v1H6v-1h12Z"
					clipRule="evenodd"
				/>
			</g>
			<defs>
				<clipPath id="b">
					<path fill="#fff" d="M6 6h12v12H6z" />
				</clipPath>
			</defs>
		</svg>
	)
}
